import '@updater-components/tooltip';
import template from './password.html';
import inlineValidationTemplate from './password-inline-validation.html';

const mod = angular
  .module('app.directives.password', [])
  .directive('password', $timeout => ({
    restrict: 'E',
    template(element, attrs) {
      // Toggle for using new validation markup/styles
      if (attrs['inlineValidation']) {
        return inlineValidationTemplate;
      } else {
        return template;
      }
    },
    scope: {
      form: '=?',
      user: '=',
      showLabel: '=',
      disableUnmask: '=',
    },
    link(scope, element, attrs) {
      /**
       * Toggle the masking
       */
      scope.toggleMask = () => (scope.unmask = !scope.unmask);
    },
  }));

export default mod;
